export const passwordRequirementsItemClassName = "password-requirements-item";

export const passwordRequirementsItemValidClassName = `${passwordRequirementsItemClassName}--valid`;

export const passwordRequirementsItemLabelClassName = `${passwordRequirementsItemClassName}__label`;

export const dotClassName = "password-requirements-dot";
